import React, {Component} from "react";
import {withNamespaces} from "react-i18next";
import {connect} from "react-redux";
import BreadcrumbExtend from "../../../components/BreadcrumbExtend";
import {deviceGroupScheduleAction} from "../../../actions/device-group-schedule.actions";
import DeviceGroupScheduleTable from "./_components/DeviceGroupScheduleTable";
import DeviceGroupScheduleExceptionTable from "./_components/DeviceGroupScheduleExceptionTable";
import {Link} from "react-router-dom";
import DeviceGroupScheduleExceptionForm from "./_forms/DeviceGroupScheduleExceptionForm";
import {modalActions} from "../../../actions/modal.actions";
import {Button} from "react-bootstrap";
import {claimTypes} from "../../../constants/claim.constants";

class DeviceGroupSchedulePage extends Component {

    componentDidMount() {
        const id = this.props.match.params.id;
        const { dispatch } = this.props;
        dispatch(deviceGroupScheduleAction.getScheduleById(id));
    }

    componentWillUnmount() {
        const { dispatch } = this.props;
        dispatch(deviceGroupScheduleAction.clearStore());
    }

    openCreateModalForm = (id) => {
        const { t, dispatch } = this.props;
        // const deviceGroupId = this.props.match.params.id;
        const modalProps = {
            open: true,
            title: t('create-schedule-exception'),
            component: <DeviceGroupScheduleExceptionForm submit={this.onHandleSubmitCreate} />,
            submitBtn: {
                className: 'btn btn-primary',
                label: 'save-changes'
            }
        };
        dispatch(modalActions.showModal({modalProps: modalProps, modalType: 'formModal'}));
    };

    onHandleSubmitCreate = (data, errorValidation) => {
        const { dispatch } = this.props;
        const deviceGroupId = this.props.match.params.id;
        delete data['id'];
        data['deviceGroupId'] = deviceGroupId;
        dispatch(deviceGroupScheduleAction.createScheduleException(data, (error) => {
            errorValidation(error)
        }));
    };

    render() {
        const { t, user, schedule, scheduleException } = this.props;

        const breadcrumb = [
            { value: 'device-group', path: '/panel/device-group' },
            { value: `${t('schedule')}` , path: '#' },
        ];

        const scheduleCrudPermission = user[`c_schedule.actions.crud`] || null;

        const goBack = this.props.history.action === "POP" ?
            (
                <div className="col">
                    <Link to="/panel/device-group" className="btn btn-secondary float-right btn-create">
                        <i className="fas fa-undo"> </i> &nbsp; { t('back-to-list') }
                    </Link>
                </div>
            ) :
            (
                <div className="col">
                    <Button variant={'secondary'}  className="float-right btn-create" onClick={() => this.props.history.goBack()}>
                        <i className="fas fa-undo"> </i> &nbsp; { t('back-to-list') }
                    </Button>
                </div>
            );


        return(
            <div>
                <BreadcrumbExtend items={breadcrumb}/>
                <div className="row">
                    <div className="col">
                        <h4>{ t('schedule') }</h4>
                    </div>
                    { goBack }
                </div>
                <div className="row mt-4">
                    <div className="col-md-6">
                        <div className="card">
                            <div className="card-header">
                                <h5>{t('schedule-list')}</h5>
                            </div>
                            <div className="card-body">
                                <DeviceGroupScheduleTable list={schedule}/>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col">
                                        <h5>{t('schedule-exception-list')}</h5>
                                    </div>
                                    <div className="col">
                                        { scheduleCrudPermission === claimTypes.READ_WRITE ? (
                                            <button className="btn btn-success float-right" onClick={ this.openCreateModalForm }>
                                                <i className="fas fa-plus"> </i> {t('create')}
                                            </button>
                                        ) : (<React.Fragment/>) }
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <DeviceGroupScheduleExceptionTable list={scheduleException} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};

const mapStateToProps = state => {
    const { schedule, scheduleException } = state.deviceGroupScheduleReducer;
    const { user } = state.authenticationReducer;
    return {
        user,
        schedule,
        scheduleException
    }
};
export default withNamespaces()(connect(mapStateToProps)(DeviceGroupSchedulePage));
